import { render, staticRenderFns } from "./SuggestionsReact.vue?vue&type=template&id=0c0f61db&"
import script from "./SuggestionsReact.vue?vue&type=script&lang=js&"
export * from "./SuggestionsReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports